import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import theme from '@sdk/theme/light';
import { ConfigProvider } from '@sdk/config/ConfigContext';
import { ClientFlagsProvider } from '@sdk/session/ClientFlagsContext';

import getConfig from '../config/getConfig';

export default (BridgedComponent: React.FC<React.PropsWithChildren<unknown>>) => {
  const config = getConfig();
  const Component = ({ ...props }): JSX.Element => (
    <ThemeProvider theme={theme}>
      <ConfigProvider config={config}>
        <ClientFlagsProvider>
          <BridgedComponent {...props} />
        </ClientFlagsProvider>
      </ConfigProvider>
    </ThemeProvider>
  );

  Component.displayName = `${BridgedComponent.name}__React2AngularComponent`;

  return Component;
};
